import Hero from "../../components/Hero";
import JourneySection from "../../components/JourneySection";
// import Footer from "../../components/Footer";

const NewHomePage = () => {
  return (
    <div className="NewHomepage">
      <Hero />
      <JourneySection />
      {/* <Footer /> */}
    </div>
  );
};

export default NewHomePage;
